import React, { useContext, useEffect } from 'react'
import { LinkContext } from '../provider/provider'
import Socials from './Socials';

function Linktab() {

    const {data, loading} = useContext(LinkContext);

    


  return (
    <div className="linktab">
    { loading ? <div>loading...</div> : 
    <div>
        {data.links.map((link, index) => {
            return(
                <div key={index} className="link">
                    <a href={link.href} rel={link.rel} target={link.target}>{link.name}</a>
                </div>
            )
        })}

        <Socials />

    </div>
    }  

  </div>
  )
}

export default Linktab